/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * File: UserDropdown.tsx
 * Project: receiving-rules
 * -----
 * Last Modified: 01 Oct 2020 8:02:25 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { ProfileOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Dropdown, Menu, Spin } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useNavigate } from 'react-router-dom';
import { useGetUserQuery } from 'redux/services/cookieMonster/cookieMonsterApi';

export enum MenuKeys {
  logout = 'Log Out',
  about = 'About',
  profile = 'Profile'
}

const styles: InlineStylesModel = {
  dropDown: {
    cursor: 'pointer'
  },
  menu: {
    alignItems: 'center',
    background: 'none',
    borderRight: 'none',
    display: 'flex',
    marginLeft: '8px'
  },
  menuIcon: {
    color: 'rgb(132, 133, 154)',
    fontSize: '18px',
    marginLeft: '5px'
  }
};

export const UserDropdown = (): JSX.Element => {
  const { logout } = useAuth0();
  const navigate = useNavigate();

  const { user } = useAuth0();
  const { data, isLoading, isFetching } = useGetUserQuery(user?.sub as string);

  const handleAboutPage = (): void => {
    navigate(`/about`);
  };
  const handleProfilePage = (): void => {
    navigate(`/profile`);
  };

  const menu = (
    <Menu disabledOverflow={true}>
      <Menu.Item onClick={handleAboutPage} key={MenuKeys.about}>
        {MenuKeys.about}
      </Menu.Item>
      <Menu.Item key={MenuKeys.profile}>
        <a target="_blank" href={process.env.REACT_APP_PROFILE_URL} rel="noreferrer">
          {MenuKeys.profile}
        </a>
      </Menu.Item>
      <Menu.Item key={MenuKeys.logout} onClick={(): void => logout({})}>
        {MenuKeys.logout}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Avatar
        icon={isLoading || isFetching ? <Spin size="small" spinning></Spin> : <ProfileOutlined />}
        style={{ marginLeft: 8, cursor: 'pointer' }}
        src={data && data.user_metadata.profile_image_url ? data.user_metadata.profile_image_url : !isLoading || !isFetching ? user?.picture : undefined}
      />
    </Dropdown>
  );
};
